import React from "react";
import { motion } from "framer-motion";

const classes = [
  {
    name: "Boxing",
    tagline: "Unleash the fighter within",
    schedule: "Mon / Wed / Fri — 6:00 AM & 7:00 PM",
    img: "https://images.unsplash.com/photo-1620123804851-70e94c55e84a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxib3hpbmclMjBjbGFzcyUyMGRhcmt8ZW58MHx8fHwxNzc0Nzg2Mzk4fDA&ixlib=rb-4.1.0&q=85",
    span: "md:col-span-2 md:row-span-2",
  },
  {
    name: "Yoga",
    tagline: "Strength through stillness",
    schedule: "Tue / Thu / Sat — 6:30 AM",
    img: "https://images.unsplash.com/photo-1602827114685-efbb2717da9f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHx5b2dhJTIwZGFyayUyMG1vZGVybnxlbnwwfHx8fDE3NzQ3ODY0MDB8MA&ixlib=rb-4.1.0&q=85",
    span: "md:col-span-1",
  },
  {
    name: "HYROX",
    tagline: "Compete. Endure. Dominate.",
    schedule: "Mon / Wed / Sat — 5:30 PM",
    img: "https://images.unsplash.com/photo-1603665409265-bdc00027c217?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwxfHxjcm9zc2ZpdCUyMGd5bSUyMGRhcmt8ZW58MHx8fHwxNzc0Nzg2NDA5fDA&ixlib=rb-4.1.0&q=85",
    span: "md:col-span-1",
  },
  {
    name: "Dance",
    tagline: "Move with purpose",
    schedule: "Tue / Thu — 8:00 PM",
    img: "https://images.unsplash.com/photo-1768851511869-b26ab0bbb5fc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxkYW5jZSUyMGNsYXNzJTIwZGFya3xlbnwwfHx8fDE3NzQ3ODY0MDh8MA&ixlib=rb-4.1.0&q=85",
    span: "md:col-span-1",
  },
  {
    name: "Zumba",
    tagline: "Cardio that feels like a party",
    schedule: "Wed / Fri / Sun — 9:00 AM",
    img: "https://images.unsplash.com/photo-1597754298097-fb51c3ec8ac8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHw0fHxkYW5jZSUyMGNsYXNzJTIwZGFya3xlbnwwfHx8fDE3NzQ3ODY0MDh8MA&ixlib=rb-4.1.0&q=85",
    span: "md:col-span-1",
  },
];

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, delay: i * 0.1 },
  }),
};

export default function ClassesSection() {
  return (
    <section id="classes" data-testid="classes-section" className="py-20 sm:py-24 lg:py-32 bg-[#121212]">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-80px" }}
          variants={fadeUp}
          custom={0}
        >
          <span className="text-[#F59E0B] text-sm font-semibold tracking-[0.3em] uppercase">Train Your Way</span>
        </motion.div>
        <motion.h2
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-80px" }}
          variants={fadeUp}
          custom={1}
          className="font-['Bebas_Neue'] text-4xl sm:text-5xl lg:text-6xl tracking-tight text-white mt-4 mb-16"
        >
          Classes & <span className="text-[#F59E0B]">Sessions</span>
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 auto-rows-[200px] md:auto-rows-[220px]">
          {classes.map((c, i) => (
            <motion.div
              key={c.name}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-60px" }}
              variants={fadeUp}
              custom={i + 2}
              data-testid={`class-${c.name.toLowerCase()}`}
              className={`group relative overflow-hidden cursor-pointer ${c.span}`}
            >
              <img
                src={c.img}
                alt={c.name}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-black/50 group-hover:bg-black/40 transition-colors duration-500" />

              <div className="relative z-10 flex flex-col justify-end h-full p-6">
                <div className="transform transition-transform duration-500 group-hover:translate-y-[-4px]">
                  <h3 className="font-['Bebas_Neue'] text-3xl md:text-4xl tracking-wide text-white group-hover:text-[#F59E0B] transition-colors duration-300">
                    {c.name}
                  </h3>
                  <p className="text-sm text-white/80 mt-1">{c.tagline}</p>
                  <p className="text-xs text-[#F59E0B]/70 mt-2 tracking-wider uppercase">{c.schedule}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
